<template>
  <v-dialog v-model="dialog" max-width="600" :fullscreen="mobile">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>{{ mdiShareVariant }}</v-icon>
      </v-btn>
    </template>

    <v-card class="dialogHeight">
      <v-card-title class="headline">
        {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.title') }}
        <v-spacer></v-spacer>
        <v-icon small v-ripple @click="dialog = false">{{ mdiClose }}</v-icon>
      </v-card-title>

      <v-card-text>
        <v-text-field ref="urlField" readonly v-model="url"></v-text-field>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="green"
          text
          @click="saveUrl">
          <v-icon left>{{ mdiContentCopy }}</v-icon>
          {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { mdiShareVariant, mdiClose, mdiContentCopy } from '@mdi/js'
import travelSelectionMixin from '../../mixins/travelSelectionMixin'
import snackbarMixin from '../../mixins/snackbarMixin'

export default {
  name: 'textCopyPopup',
  mixins: [travelSelectionMixin, snackbarMixin],
  data: () => ({
    dialog: false,
    mdiShareVariant: mdiShareVariant,
    mdiClose: mdiClose,
    mdiContentCopy: mdiContentCopy
  }),
  props: {
    travelId: Number,
    criticalId: {
      type: Number,
      default: null
    }
  },
  computed: {
    mobile () {
      return ['xs'].includes(this.$vuetify.breakpoint.name)
    },
    url () {
      let result = `${document.location.origin + document.location.pathname}?travel=${this.travelId}`
      if (this.criticalId) {
        result += `&critical=${this.criticalId}`
      }
      return result
    }
  },
  methods: {
    saveUrl () {
      this.dialog = false
      this.$copyText(this.url, this.$refs.urlField.$el)
        .then((e) => {
          this.openSuccessSnackbar('$vuetify.map.textCopyPopup.success')
        })
        .catch((e) => {
          console.error(e)
          this.openFailureSnackbar('$vuetify.map.textCopyPopup.failure')
        })
    }
  }
}
</script>

<style scoped>
  .dialogHeight {
    height: 200px;
    overflow-y: hidden;
  }

  .mobile-button {
    margin: 0 0 0 -350px;
  }
</style>
